import { render, staticRenderFns } from "./WarehouseRemove.vue?vue&type=template&id=01b6bf48&"
import script from "./WarehouseRemove.vue?vue&type=script&lang=js&"
export * from "./WarehouseRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b6bf48')) {
      api.createRecord('01b6bf48', component.options)
    } else {
      api.reload('01b6bf48', component.options)
    }
    module.hot.accept("./WarehouseRemove.vue?vue&type=template&id=01b6bf48&", function () {
      api.rerender('01b6bf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Warehouse/components/Warehouse/WarehouseRemove.vue"
export default component.exports